import { render, staticRenderFns } from "./forms-category-document-modal.vue?vue&type=template&id=31b1fb8c&"
import script from "./forms-category-document-modal.vue?vue&type=script&lang=js&"
export * from "./forms-category-document-modal.vue?vue&type=script&lang=js&"
import style0 from "./forms-category-document-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports